<app-dialog [dialogTitle]="'public.profile.deleteConfirmTitle' | translate">
  <form [formGroup]="deleteProfileForm" class="mt-2" (ngSubmit)="handleSubmit($event)">
    <app-dialog-content class="content">
      <div class="font-size-primary p-2 mb-3 delete-confirmation-text">
        {{ 'public.profile.deleteConfirmAlert' | translate }}
      </div>
      <div class="font-size-primary mb-3">
        {{ 'public.profile.deleteConfirmEmail' | translate }}
      </div>

      <!-- Email -->
      <div class="form-group full-width">
        <app-input-text class="mb-4" inputId="email" maxLength="200" [label]="'public.checkout.email' | translate"
          [required]="true" [control]="getControl('emailConfirm')" [inputType]="'email'" [errorText]="errorMessage"
          [isInvalid]="!!errorMessage" [placeholder]="data.email" />
      </div>
    </app-dialog-content>
    <app-dialog-actions>


      <div class="row button-row">
        <span class="mr-3 mb-3">
          <app-button [mat-dialog-close]="false" startIcon="fa-check">
            {{ 'public.profile.keepAccount' | translate }}
          </app-button>
        </span>
        <span>
          <app-button variant="danger" type="submit" startIcon="fa-trash">
            {{ 'public.profile.delete' | translate }}
          </app-button>
        </span>
      </div>
    </app-dialog-actions>
  </form>
</app-dialog>